import '/app/brewery-packages/content/content-editor-plugin-emphasis/src/Emphasis.css-raw';
export default {
  "emphasis": "contacts-cbf4f629-emphasis-Ihm-DG"
};